module.exports = __webpack_public_path__ + "img/close_square.0ae1d351.svg";